import Vue from 'vue';
import Vuex from 'vuex';
import tutorials from './modules/tutorials';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    tutorials,
  },
  strict: debug,
  plugins: [],
});
